import parent from '../../path';

export const resource = `${parent}/resource`;

export const newResource = `${resource}/new`;

export const matchResource = `${resource}/:id`;

export default resource;
